import moment from "moment";
import { LaporanOperasi } from "@/types/laporan_operasi";

export const LAPOP_TINDAKAN_OPTIONS = [
  { id: "t1", name: "Partus Pervaginam" },
  { id: "t2", name: "Vaccum Ekstrasi" },
  { id: "t3", name: "Sectio Caesaria" },
  { id: "t4", name: "Kuretase" },
  { id: "t5", name: "Kuretase PUA" },
  { id: "t6", name: "Umum" }
];

export function namaTindakanLabel(item: Partial<LaporanOperasi>): string {
  if (item?.category_text) return item.category_text;
  const opt = LAPOP_TINDAKAN_OPTIONS.find(o => o.id === item?.category);
  return opt ? opt.name : "-";
}

export function tglOperasi(dateString: string | undefined): string {
  if (!dateString) return "-";
  return moment(dateString).format("DD-MM-YYYY");
}

export function laporanOperasiHeaders(short: boolean) {
  if (short) {
    return [
      { text: "#", value: "index", sortable: false, width: "20px" },
      { text: "Nama Tindakan", value: "category_text" },
      { text: "Tanggal Operasi", value: "op_started_at" },
      { text: "DPJP", value: "dr_operator1" }
    ];
  }

  return [
    { text: "#", value: "index", sortable: false, width: "20px" },
    { text: "Nama Tindakan", value: "category_text" },
    { text: "Tanggal Operasi", value: "op_started_at" },
    { text: "Diagnosis Pasca Tindakan", value: "diag_pasca" },
    { text: "DPJP", value: "dr_operator1" },
    { text: "Aksi", value: "aksi" }
  ];
}
